// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"3df9091a","787":"f5afda6a","807":"65e4bd6b","819":"352dd6f5","971":"28c88ae1"}[chunkId] + ".chunk.js";
};